import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginSliderImagesProperties } from '../Models/LoginSliderImagesProperties';
import { CMSService } from '../Services/cms.service';
import { Canvg } from 'canvg';

@Component({
  selector: 'app-cms-login-slider-images',
  templateUrl: './cms-login-slider-images.component.html',
  styleUrls: ['./cms-login-slider-images.component.css']
})
export class CmsLoginSliderImagesComponent implements OnInit {
  loginSliderImageData: LoginSliderImagesProperties[] = [];
  loginSliderImageObj = new LoginSliderImagesProperties();
  isLoadPanelVisible: boolean = false;
  url: string | ArrayBuffer;
  updateFileImage: any;
  ValidateFileFormat: boolean;
  imagePath: string = "";
  message: string = "";
  ssvgurl: string;
  createFileImage: any;
  hideIdField: boolean = true;
  constructor(private cmsService: CMSService, private modalService: NgbModal,) { }
  //contentReady = () => {
  //  $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold", "font-size": "15px" });

  //};
  ngOnInit() {
    this.isLoadPanelVisible = true;

    this.GetLoginSliderImges();

  }
  GetLoginSliderImges() {
    this.cmsService.getLoginSliderImges().subscribe((data) => {
      if (data != null) {
        this.isLoadPanelVisible = false;
        this.loginSliderImageData = data;
      }
    })

   
  }

  DeleteLoginSliderImage(id, targetmodel, model) {
    console.log(id);
    this.cmsService.DeleteSliderImage(id).subscribe((data) => {
      if (data == true) {
        this.GetLoginSliderImges();
        this.modalService.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
        setTimeout(() => { this.modalService.dismissAll() }, 5000);
      }
      else {
        this.modalService.open(model, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
      }
    })
  }

  updatepopup(data, targetmodel) {
    this.loginSliderImageObj.id = data.id;
    this.loginSliderImageObj.imageName = data.imageName;
    this.loginSliderImageObj.status = data.status;
    this.url = data.Logo;
    this.loginSliderImageObj.logo = data.logo;
    this.updateFileImage = data.airlineLogo;
    //console.log(data);
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }


  onFileChanged(event, targetmodel) {
    this.url = "";
    const files = event.target.files;
    this.updateFileImage = event.target.files[0].name;
    this.loginSliderImageObj.logo = event.target.files[0];
    if (files.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
        imageurl.style.display = "none";
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.url = "";
          this.url = processedimage;




        }

      }
      else {

        this.ssvgurl = "";
        const reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this.url = reader.result;

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.url = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
    //document.body.removeChild(document.getElementById("newcanvas"));
    this.modalService.dismissAll();
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }

  onFileChangedCreate(event, targetmodel) {
    this.ssvgurl = "";
    const filess = event.target.files;
    this.createFileImage = event.target.files[0];
    this.loginSliderImageObj.logo = event.target.files[0];
    if (filess.length === 0) {
      return;
    }
    const filename = event.target.files[0].name;
    const mimeType = filess[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    if (this.validateFileType(filename) == true) {
      var idxDot = filename.lastIndexOf(".") + 1;
      var extFile = filename.substr(idxDot, filename.length).toLowerCase();
      if (extFile == "svg") {
        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        let imageurl = document.getElementById("svg") as HTMLImageElement;
        imageurl.style.display = "none";
        reader.onload = async (_event) => {

          imageurl.src = (reader.result).toString();
          const canvass = document.createElement('canvas');
          canvass.id = "newcanvas";
          canvass.width = 250;
          canvass.height = 250;
          const ctx = canvass.getContext('2d');
          /* ctx.clearRect(0, 0, canvass.width, canvass.height);*/
          const v = await Canvg.from(ctx, imageurl.src);

          v.start();
          var processedimage = canvass.toDataURL("img/png");
          //var s = new XMLSerializer().serializeToString(imageurl.src);
          //var encodedData = window.btoa(s);
          //this.ssvgurl = encodedData;
          this.ssvgurl = "";
          this.ssvgurl = processedimage;




        }

      }
      else {


        const reader = new FileReader();
        this.imagePath = filess;
        reader.readAsDataURL(filess[0]);
        reader.onload = (_event) => {
          this.ssvgurl = (reader.result).toString();

        }
      }


    }
    else {

      document.getElementById("messageLogo1").innerHTML = "Only .svg & .png Formats Are Allowed";
      this.url = "";
      setTimeout(() => { document.getElementById("messageLogo1").innerHTML = ""; }, 5000);
      return;
    }
    //document.body.removeChild(document.getElementById("newcanvas"));
    this.modalService.dismissAll();
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }

  validateFileType(fileName): boolean {

    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile == "svg" || extFile == "png") {
      //TO DO
      this.ValidateFileFormat = true;
    } else {
      this.ValidateFileFormat = false;
    }
    return this.ValidateFileFormat;
  }
  popupCreateModel(targetmodel) {
    this.modalService.open(targetmodel, {

      /* windowClass: "searchpassengerpopupmodal"*/

      size: 'lg',
    })
  }
  CreateCmsSliderImage(event, targetmodel, bad) {

    //if (this.airlineMasterCreateObj.airlineCombineCode == undefined || this.airlineMasterCreateObj.airlineCombineCode == null ||
    //  this.airlineMasterCreateObj.airlineCombineCode == "") {
    //  document.getElementById("airlineCombineCode1").innerHTML = 'Required';
    //  document.getElementById("combineinput").style.borderColor = "red";
    //  document.getElementById("combineinput").style.boxShadow = "0 0 3px red";
    //  setTimeout(() => {
    //    document.getElementById("airlineCombineCode1").innerHTML = '';
    //    document.getElementById("combineinput").style.borderColor = "";
    //    document.getElementById("combineinput").style.boxShadow = "";
    //  }, 5000);
    //}
    //if (this.airlineMasterCreateObj.airlineLegalName == undefined || this.airlineMasterCreateObj.airlineLegalName == null ||
    //  this.airlineMasterCreateObj.airlineLegalName == "") {
    //  document.getElementById("airlineLegalName1").innerHTML = 'Required';
    //  document.getElementById("legalinput").style.borderColor = "red";
    //  document.getElementById("legalinput").style.boxShadow = "0 0 3px red";
    //  setTimeout(() => {
    //    document.getElementById("airlineLegalName1").innerHTML = '';
    //    document.getElementById("legalinput").style.borderColor = "";
    //    document.getElementById("legalinput").style.boxShadow = "";
    //  }, 5000);
    //}
    //if (this.airlineMasterCreateObj.airlinePrefixCode == undefined || this.airlineMasterCreateObj.airlinePrefixCode == null ||
    //  this.airlineMasterCreateObj.airlinePrefixCode == "") {
    //  document.getElementById("airlinePrefixCode1").innerHTML = 'Required';
    //  document.getElementById("prefixinput").style.borderColor = "red";
    //  document.getElementById("prefixinput").style.boxShadow = "0 0 3px red";
    //  setTimeout(() => {
    //    document.getElementById("airlinePrefixCode1").innerHTML = '';
    //    document.getElementById("prefixinput").style.borderColor = "";
    //    document.getElementById("prefixinput").style.boxShadow = "";
    //  }, 5000);
    //}
    //if (this.airlineMasterCreateObj.airlineNumCode == undefined || this.airlineMasterCreateObj.airlineNumCode == null ||
    //  this.airlineMasterCreateObj.airlineNumCode == "") {
    //  document.getElementById("airlineNumCode1").innerHTML = 'Required';
    //  document.getElementById("numberinput").style.borderColor = "red";
    //  document.getElementById("numberinput").style.boxShadow = "0 0 3px red";
    //  setTimeout(() => {
    //    document.getElementById("airlineNumCode1").innerHTML = '';
    //    document.getElementById("numberinput").style.borderColor = "";
    //    document.getElementById("numberinput").style.boxShadow = "";
    //  }, 5000);
    //}

    //if (this.airlineMasterCreateObj.airlineLogo == undefined || this.airlineMasterCreateObj.airlineLogo == null ||
    //  this.airlineMasterCreateObj.airlineLogo == "") {
    //  document.getElementById("messageLogo1").innerHTML = 'Required';

    //  setTimeout(() => {
    //    document.getElementById("messageLogo1").innerHTML = '';

    //  }, 5000);
    //}
    if (this.loginSliderImageObj.logo == undefined || this.loginSliderImageObj.logo == null ||
      this.loginSliderImageObj.logo == "" || this.loginSliderImageObj.imageName == undefined || this.loginSliderImageObj.imageName == null ||
      this.loginSliderImageObj.imageName == "")
    {
      return;
    }
    var formData = new FormData();

    formData.append("sliderID", (this.loginSliderImageObj.id).toString());
    formData.append("imageName", this.loginSliderImageObj.imageName);
    formData.append("imageStatus", this.loginSliderImageObj.status);
    formData.append("userId", (localStorage.getItem("UserId")));
    formData.append(this.createFileImage.name, this.loginSliderImageObj.logo)
    this.cmsService.CreateSliderImage(formData).subscribe((data) => {
      if (data == true) {
        this.GetLoginSliderImges();
        this.modalService.dismissAll();
        this.modalService.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
        setTimeout(() => { this.modalService.dismissAll() }, 5000);
      }

      else {
        this.modalService.open(bad, {

          /* windowClass: "searchpassengerpopupmodal"*/

          windowClass: "alertpopupmodal"
        })
        setTimeout(() => { this.modalService.dismissAll() }, 5000);
      }

    })
  }



  UpdateCmsSlider(event, targetmodel, bad) {
    try {

      //if (this.airlineMasterObj.airlineCombineCode == undefined || this.airlineMasterObj.airlineCombineCode == null ||
      //  this.airlineMasterObj.airlineCombineCode == "") {
      //  document.getElementById("airlineCombineCode2").innerHTML = 'Required';
      //  document.getElementById("combineinput").style.borderColor = "red";
      //  document.getElementById("combineinput").style.boxShadow = "0 0 3px red";
      //  setTimeout(() => {
      //    document.getElementById("airlineCombineCode2").innerHTML = '';
      //    document.getElementById("combineinput").style.borderColor = "";
      //    document.getElementById("combineinput").style.boxShadow = "";
      //  }, 5000);
      //}
      //if (this.airlineMasterObj.airlineLegalName == undefined || this.airlineMasterObj.airlineLegalName == null ||
      //  this.airlineMasterObj.airlineLegalName == "") {
      //  document.getElementById("airlineLegalName2").innerHTML = 'Required';
      //  document.getElementById("legalinput").style.borderColor = "red";
      //  document.getElementById("legalinput").style.boxShadow = "0 0 3px red";
      //  setTimeout(() => {
      //    document.getElementById("airlineLegalName2").innerHTML = '';
      //    document.getElementById("legalinput").style.borderColor = "";
      //    document.getElementById("legalinput").style.boxShadow = "";
      //  }, 5000);
      //}
      //if (this.airlineMasterObj.airlinePrefixCode == undefined || this.airlineMasterObj.airlinePrefixCode == null ||
      //  this.airlineMasterObj.airlinePrefixCode == "") {
      //  document.getElementById("airlinePrefixCode2").innerHTML = 'Required';
      //  document.getElementById("prefixinput").style.borderColor = "red";
      //  document.getElementById("prefixinput").style.boxShadow = "0 0 3px red";
      //  setTimeout(() => {
      //    document.getElementById("airlinePrefixCode2").innerHTML = '';
      //    document.getElementById("prefixinput").style.borderColor = "";
      //    document.getElementById("prefixinput").style.boxShadow = "";
      //  }, 5000);
      //}
      //if (this.airlineMasterObj.airlineNumCode == undefined || this.airlineMasterObj.airlineNumCode == null ||
      //  this.airlineMasterObj.airlineNumCode == "") {
      //  document.getElementById("airlineNumCode2").innerHTML = 'Required';
      //  document.getElementById("numberinput").style.borderColor = "red";
      //  document.getElementById("numberinput").style.boxShadow = "0 0 3px red";
      //  setTimeout(() => {
      //    document.getElementById("airlineNumCode2").innerHTML = '';
      //    document.getElementById("numberinput").style.borderColor = "";
      //    document.getElementById("numberinput").style.boxShadow = "";
      //  }, 5000);
      //}
      //if (this.airlineMasterObj.airlineLogo == undefined || this.airlineMasterObj.airlineLogo == null ||
      //  this.airlineMasterObj.airlineLogo == "") {
      //  document.getElementById("messageLogo1").innerHTML = 'Required';

      //  setTimeout(() => {
      //    document.getElementById("messageLogo1").innerHTML = '';

      //  }, 5000);
      //}
      //if (this.airlineMasterObj.airlineStatus == undefined || this.airlineMasterObj.airlineStatus == null ||
      //  this.airlineMasterObj.airlineStatus == "") {
      //  document.getElementById("airlineStatus2").innerHTML = 'Required';
      //  document.getElementById("statusinput2").style.borderColor = "red";
      //  document.getElementById("statusinput2").style.boxShadow = "0 0 3px red";
      //  setTimeout(() => {
      //    document.getElementById("airlineStatus2").innerHTML = '';
      //    document.getElementById("statusinput2").style.borderColor = "";
      //    document.getElementById("statusinput2").style.boxShadow = "";
      //  }, 5000);
      //}
      if (this.loginSliderImageObj.logo == undefined || this.loginSliderImageObj.logo == null ||
        this.loginSliderImageObj.logo == "" || this.loginSliderImageObj.imageName == undefined || this.loginSliderImageObj.imageName == null ||
        this.loginSliderImageObj.imageName == "" || this.loginSliderImageObj.status == undefined || this.loginSliderImageObj.status == null ||
        this.loginSliderImageObj.status == "" ) {
        return;
      }
      var formData = new FormData();

      formData.append("cmsSliderId", (this.loginSliderImageObj.id).toString());
      formData.append("cmsImageName", this.loginSliderImageObj.imageName);
      formData.append("sliderLogoName", this.loginSliderImageObj.sliderLogoName);
      formData.append("cmsSlideStatus", this.loginSliderImageObj.status);
      formData.append("cmsLogo", this.updateFileImage);
      formData.append("userId", (localStorage.getItem("UserId")));
      formData.append(this.updateFileImage, this.loginSliderImageObj.logo)
      this.cmsService.UpdateSliderImage(formData).subscribe((data) => {
        if (data == true) {
          this.modalService.dismissAll();
          this.GetLoginSliderImges();
        }

        else {
          this.modalService.open(bad, {

            /* windowClass: "searchpassengerpopupmodal"*/

            windowClass: "alertpopupmodal"
          })
          setTimeout(() => { this.modalService.dismissAll() }, 5000);
        }

      })
    }
    catch (e) {
      console.log(e);
    }
  }
}
